export const ABOUT_PAGE_CONTENT = `\
# About Me

Hello! My name is Amir 👋 and I have a keen interest in automation and ML

I started my journey in 2020, starting with basic HTML / CSS / JS.
Since then, I've been immersed in creating everything from web apps 💻 to ML-powered gaming bots 🎮🧠.

(Game bots were and still are my favorite projects!)

Currently, I'm as a software engineer at PIMCO and
am pursuing a BS in Computer Science at [WGU](https://wgu.edu).
Alongside my studies, I'm tackling a few machine learning projects to sharpen my skills and
explore new technologies.

In my free time, I enjoy keeping up with the latest in AI and ML 📚.

For a fascinating read on the future of technology, I recommend [Peter Diamandis' "Abundance"](https://www.google.com/search?q=peter+diamandis+abundance).
`